import type { WholesaleStatus } from "@/lib/wholesale";
import type { Shipping } from "@/services/wholesale-orders";

/** Statusi u kojima se narudžba više ne uređuje. */
export const LOCKED: WholesaleStatus[] = ["shipped", "completed", "cancelled"];

export type EmailKind = "confirmed" | "updated" | "shipped";

export const EMAIL_KINDS: { kind: EmailKind; label: string }[] = [
  { kind: "confirmed", label: "Potvrda narudžbe" },
  { kind: "updated", label: "Izmjena narudžbe" },
  { kind: "shipped", label: "Obavijest o slanju" },
];

export const EMAIL_KIND_LABEL: Record<string, string> = Object.fromEntries(EMAIL_KINDS.map((e) => [e.kind, e.label]));

/** Statusi posla upisa zalihe iz `wholesale_stock_jobs`; nepoznat token se ispisuje kakav jest. */
export const STOCK_JOB_STATUS_LABEL: Record<string, string> = {
  pending: "U redu čekanja",
  done: "Upisano",
  failed: "Nije upisano",
};

export const METHOD_LABEL: Record<string, string> = { bank: "Virman", cash: "Gotovina" };

export type ShippingFieldKey = Exclude<keyof Shipping, "country">;

export const SHIPPING_FIELDS: readonly [ShippingFieldKey, string][] = [
  ["name", "Naziv"], ["contact", "Kontakt osoba"], ["phone", "Telefon"],
  ["address", "Adresa"], ["city", "Grad"], ["postalCode", "Poštanski broj"],
];

export const EMPTY_SHIPPING: Shipping = {
  name: "", contact: "", phone: "", address: "", city: "", postalCode: "", country: "BA",
};

/** Statusi narudžbi na koje se može knjižiti uplata (nacrt i otkazana nemaju dug). */
export const PAYABLE_STATUSES: WholesaleStatus[] = ["confirmed", "packed", "shipped", "completed"];

/** Adresa dostave prepisana iz partnera — isti prefill koriste i nova narudžba i
 *  prezentacijski mod, pa polja ne smiju odlutati jedno od drugog. */
export function shippingFromPartner(p: {
  name?: string | null; contactName?: string | null; phone?: string | null;
  address?: string | null; city?: string | null; postalCode?: string | null; country?: string | null;
}): Shipping {
  return {
    name: p.name ?? "",
    contact: p.contactName ?? "",
    phone: p.phone ?? "",
    address: p.address ?? "",
    city: p.city ?? "",
    postalCode: p.postalCode ?? "",
    country: p.country || "BA",
  };
}
